module.exports = __webpack_public_path__ + "img/2.320c676a.png";